import { render, staticRenderFns } from "./SelectionsTable.vue?vue&type=template&id=6ff42840&scoped=true&"
import script from "./SelectionsTable.vue?vue&type=script&lang=js&"
export * from "./SelectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectionsTable.vue?vue&type=style&index=0&id=6ff42840&prod&lang=css&"
import style1 from "./SelectionsTable.vue?vue&type=style&index=1&id=6ff42840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff42840",
  null
  
)

export default component.exports